<template>
  <div class="content-wrappper">
    <notification-header :addedServices="addedServices" :loaderStatus="loaderStatus" :notificationsStarMarkCount="notificationsStarMarkCount" :notificationsCount="notificationsCount" :startDate.sync="startDate" :endDate.sync="endDate" :notificationTabName.sync="notificationTabName" :roleId="roleId" :showSEFlag="showSEFlag"></notification-header>
    <notification-reg-tracker v-if="notificationTabName == 'registration-tracker'" :startDate="startDate" :endDate="endDate" :notificationsStarMarkCount="notificationsStarMarkCount" type="compliance-notifications"></notification-reg-tracker>
    <notification-reg-watch v-if="notificationTabName == 'regulatory-watch'" :startDate="startDate" :endDate="endDate"></notification-reg-watch>
    <notification-general v-if="notificationTabName == 'general-notifications'" :startDate="startDate" :endDate="endDate" :notificationsStarMarkCount="notificationsStarMarkCount"></notification-general>
    <notification-smart-builder v-if="notificationTabName == 'smart-builder'" :startDate="startDate" :endDate="endDate" :notificationsStarMarkCount="notificationsStarMarkCount"></notification-smart-builder>
    <notification-smart-exchange v-if="notificationTabName == 'smart-exchange'" :startDate="startDate" :endDate="endDate" :notificationsStarMarkCount="notificationsStarMarkCount"></notification-smart-exchange>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import * as moment from 'moment';
import NotificationHeader from './NotificationHeader.vue';
import Loader from '../UIComponents/Loader.vue';
import NotificationRegTracker from './NotificationRegTracker.vue';
import NotificationGeneral from './NotificationGeneral.vue';
import { getUserNewNotificationsCount, getAllActiveServiceCounts } from '../../apis/notification';
import { getActiveServices } from '../../apis/marketPlace';
import EventBus from '../../utils/event-bus';

export default {
  components: {
    NotificationRegTracker,
    NotificationGeneral,
    NotificationHeader,
    Loader,
  },
  data() {
    return {
      showSEFlag: false,
      roleId: JSON.parse(localStorage.getItem('userData')).role_id,
      startDate: '',
      endDate: '',
      notificationsStarMarkCount: {},
      notificationsCount: '',
      account_id: JSON.parse(localStorage.getItem('userData')).account_id,
      notificationTabName: '',
      addedServices: [],
      loaderStatus: false,
    };
  },
  watch: {
    startDate() {
      console.log(this.startDate);
    },
  },
  mounted() {
    EventBus.$on('newNotificationsCount', async (newNotificationsCount) => {
      this.notificationsStarMarkCount = newNotificationsCount;
      await this.getAllActiveServicesCounts();
      EventBus.$emit('loadActiveNotificationTab');
    });
    EventBus.$on('updateRegWatch', async () => {
      await this.getAllActiveServicesCounts();
    });
  },
  methods: {
    validateDefaultTab() {
      this.addedServices.some((addedService) => {
        if (addedService === 1) {
          this.notificationTabName = 'registration-tracker';
          return true;
        }
        if (addedService === 4) {
          this.notificationTabName = 'regulatory-watch';
          return true;
        }
        if (addedService === 3 && !this.addedServices.includes(4)) { // First highlight reg watch if Reg watch service not there then SB
          this.notificationTabName = 'smart-builder';
          return true;
        }
        return false;
      });
      if (this.notificationTabName === '') {
        this.notificationTabName = 'general-notifications';
      }
    },
    defaultStartAndEndDates() {
      const todayDate = new Date();
      const oneMonthOldDate = new Date();
      oneMonthOldDate.setMonth(oneMonthOldDate.getMonth() - 1);
      this.startDate = oneMonthOldDate;
      this.endDate = todayDate;
    },
    async getAllActiveServicesCounts() { // To show count on tab level
      this.loaderStatus = true;
      if (this.roleId !== 4 && this.roleId !== 6) {
        this.addedServices.push('sx_notification');
      }
      const requestObj = {
        start_date: moment(this.startDate).format('YYYY-MM-DD'),
        end_date: moment(this.endDate).format('YYYY-MM-DD'),
        services_list: this.addedServices,
      };
      if (requestObj.start_date === 'Invalid date' || requestObj.end_date === 'Invalid date') {
        this.loaderStatus = false;
        return;
      }
      this.notificationsCount = await getAllActiveServiceCounts(requestObj);
      this.loaderStatus = false;
    },
    async getNewNotificationsCount() { // To highlight for new notifications on tab level
      const response = await getUserNewNotificationsCount();
      this.notificationsStarMarkCount = response;
    },
    async getAllPremiumServices() { // To know active services for tab level
      const accoountServices = await getActiveServices(localStorage.getItem('accountId'));
      this.addedServices = accoountServices.services || [];
      console.log('sample', this.addedServices);
    },
  },
  beforeDestroy() {
    EventBus.$off('newNotificationsCount');
    EventBus.$off('updateRegWatch');
  },
  async created() {
    this.loaderStatus = true;
    this.defaultStartAndEndDates();
    await this.getAllPremiumServices();
    await this.getNewNotificationsCount();
    await this.getAllActiveServicesCounts();
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      console.log('router', language, oldLanguage);
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
    this.validateDefaultTab();
    this.loaderStatus = false;
  },
};
</script>
<style scoped>
</style>
